import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/FavoritesLandingMerchants';

export const FAVORITES_LANDING_MERCHANTS_ADD_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const FAVORITES_LANDING_MERCHANTS_ADD_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const FAVORITES_LANDING_MERCHANTS_REMOVE = `${rootActionPath}/REMOVE`;
export const FAVORITES_LANDING_MERCHANTS_LOAD = `${rootActionPath}/LOAD`;
